import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  tokenSolver,
  getFromStorage,
  awards,
  scrollToTop,
  privBalanceKey,
  getImg,
  toggleScrollLock,
  getCardDetail,
} from "../utils";
import { chevron_left, empty_awards } from "./../pngs";
import {
  CoalitionSpinner,
  CoalitionModal,
  EmptyBlock,
  CoalitionButton,
  CoalitionCardAwards,
  CoalitionCardAwardsDetail,
  isTokenValid,
} from "../components";

export const AwardsPage = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [awardsCards, updateAwardsCards] = useState([]);
  const balance = localStorage.getItem(privBalanceKey);

  useEffect(() => {
    if (!isTokenValid()) return navigate("/unauth");
    const setAwardsCards = async () => {
      setLoading(true);
      const rawAwards = getFromStorage(awards);
      await updateAwardsCards(rawAwards);
      setLoading(false);
      scrollToTop();
    };
    setAwardsCards();
  }, []);

  return loading ? (
    <CoalitionSpinner />
  ) : (
    <div className="specific-page">
      <PagePrebuilt
        awards={awardsCards}
        balance={balance}
        buttonClicked={() => navigate(`/?${tokenSolver()}`)}
      />
    </div>
  );
};

const PagePrebuilt = ({ awards = [], balance, buttonClicked }) => {
  const [modal, setModal] = useState();
  const [shown, setShown] = useState(false);
  const [activeCard, setActiveCard] = useState();

  const toggleModal = (modal = false) => {
    setShown(Boolean(modal));
    toggleScrollLock();
    setActiveCard(getCardDetail(awards, modal));
  };

  return (
    <>
      {!awards || awards.length === 0 ? (
        <>
          <EmptyBlock
            title={"Premios disponibles"}
            description={
              "Muy pronto podrás cambiar tus puntos por tus productos favoritos"
            }
            emptyState={empty_awards}
          >
            <CoalitionButton
              label="Volver al Inicio"
              klass="coalition-button-go-dashboard"
              onClickEvent={buttonClicked}
            />
          </EmptyBlock>
        </>
      ) : (
        <>
          <div className="carousel-cards">
            <>
              <CoalitionButton
                label={"Premios"}
                klass="nav-button"
                onClickEvent={buttonClicked}
              >
                {getImg(chevron_left, "back-icon")}
              </CoalitionButton>
            </>
            <div className="title">{"Premios disponibles"}</div>
            <div className="description">
              {"Cambia tus puntos por productos de regalo"}
            </div>
            {awards.map((i, k) => (
              <CoalitionCardAwards
                key={k}
                id={i.id}
                product={i.image}
                title={i.title}
                pointsRequired={i.pay_in_points}
                points={balance}
                showModal={(cardId) => toggleModal(cardId)}
              />
            ))}
          </div>
          {shown ? (
            <CoalitionModal
              modalRef={(n) => setModal(n)}
              closeModal={() => toggleModal()}
              onKeyDown={(e) => (e.keyCode === 27 ? toggleModal() : null)}
              onClickOutside={(e) =>
                modal && modal.contains(e.target) ? null : toggleModal()
              }
              title={"Todo sobre el premio"}
            >
              <CoalitionCardAwardsDetail card={activeCard} balance={balance} />
            </CoalitionModal>
          ) : null}
        </>
      )}
    </>
  );
};
